/**
 * GritVue X1 RX Insert™: a future accessory, prototype in development.
 * It is NOT required to buy or use the X1. The X1 is prescription ready today.
 */

/**
 * RX_INSERT_UPDATES_URL · where "Get RX Insert updates" sends people
 * (e.g. a Shopify or Klaviyo signup page). Leave empty until it exists:
 * the button then opens a pre-filled email to support instead of a broken page.
 */
export const RX_INSERT_UPDATES_URL = ''

export const RX_INSERT_FALLBACK_MAILTO =
  'mailto:support@gritvuegear.com?subject=RX%20Insert%20updates&body=Please%20let%20me%20know%20when%20the%20GritVue%20X1%20RX%20Insert%20is%20ready.'

export interface RxInsertImage {
  /** Paste the real GritVue prototype photo URL. Empty slots are not rendered. */
  src: string
  alt: string
  caption: string
}

/** Prototype image slots. Only slots with a src appear on the page. Never use generic stock glasses. */
export const rxInsertImages: RxInsertImage[] = [
  { src: '', alt: 'GritVue X1 RX Insert prototype on its own', caption: 'RX Insert prototype' },
  { src: '', alt: 'RX Insert prototype positioned behind the main X1 lens', caption: 'Sits behind the main lens' },
  { src: '', alt: 'RX Insert prototype installed inside the X1 frame', caption: 'Installed in the X1' },
  { src: '', alt: 'Outer X1 lens and RX Insert shown separated', caption: 'Outer lens + RX Insert' },
  { src: '', alt: 'Close-up of the RX Insert prototype', caption: 'Prototype close-up' },
]
